export default class HttpService {
  url = "https://abhyaas.edmark.in/api";
  // url = "http://127.0.0.1:8000/api";
  postData = async (item, added_url, tokenId = "") => {
    const token = await localStorage.getItem(tokenId);
    alert(token);
    const requestOptions = this.postRequestOptions(token, item);
    return fetch(this.url + "/" + added_url, requestOptions).then((response) =>
      response.json()
    );
  };
  postDataToken = async (item, added_url,se_token) => {
    const token = se_token;
    const requestOptions = this.postRequestOptions(token, item);
    return fetch(this.url + "/" + added_url, requestOptions).then((response) =>
      response.json()
    );
  };
  getData = async (added_url, tokenId = "") => {
    const token = await localStorage.getItem(tokenId);
    const requestOptions = this.getRequestOptions(token);
    return fetch(this.url + "/" + added_url, requestOptions).then((response) =>
      response.json()
    );
  };
  getRequestOptions = (token) => {
    let requestOptions = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
    };
    return requestOptions;
  };
  postRequestOptions = (token, item) => {
    let requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
      body: JSON.stringify(item),
    };
    return requestOptions;
  };
    postRequestOptionsClient = (client, item) => {
    let requestOptions = {
      method: "POST",
      headers: {
        Authorization: client,
        "Content-type": "application/json",
      },
      body: JSON.stringify(item),
    };
    return requestOptions;
  };
  postDataClient = async (item, added_url, client) => {
    const requestOptions = this.postRequestOptionsClient(client, item);
    return fetch(this.url + "/" + added_url, requestOptions).then((response) =>
      response.json()
    );
  };
}
